<ng-template #settingsDrawer let-offcanvas>
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title fw-normal" id="table-settings">Table Settings</h5>
    <button type="button" class="btn-close" (click)="offcanvas.dismiss()" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <app-multi-branch-selector (branchesSelected)="onBranchesSelected($event)"/>

    <app-multi-project-type-selector
      [selectedTypes]="pendingSettings.projectTypes"
      (typesSelected)="onTypesSelected($event)"
    />

    <app-date-range-selector (dateRangeChanged)="onPendingDateRangeChanged($event)" [fromDate]="pendingSettings.fromDate"
                             [toDate]="pendingSettings.toDate"/>
  </div>
  <div class="offcanvas-footer border-top p-3">
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="resetToDefault()">
        Reset to Default
      </button>
      <button type="button" class="btn btn-primary" (click)="applySettings()">
        Apply Settings
      </button>
    </div>
  </div>
</ng-template>

<div class="container-fluid p-4">

  <groundworks-listbox
    [title]="'Unscheduled Projects Task List'"
    [tabs]="tabs()"
    [config]="config"
    [items]="items()"
    [loading]="isLoading()"
    [error]="errorMessage()"
    [filterItems]="activeTags()"
    [filterClearAction]="clearAllTags"
    [showSearch]="true"
    [showSettings]="true"
    [showPagination]="true"
    [noDataMessage]="noDataMessage()"
    (actionClick)="onJobClick($event)"
    (settingsClick)="openSettings()"/>
</div>
